import { httpClient } from '@/services/http/httpClient'

import type { Option } from '@/types/option'

type IdeasToLinkHttpResponse = {
  ideas: {
    id: string
    sequence: number
    title: string
  }[]
}

export type IdeasToLinkParams = {
  search: string
  ideaId: string
}

export type IdeaToLink = Option & {
  sequence: string
}

export async function getIdeasToLink({
  ideaId,
  search,
}: IdeasToLinkParams): Promise<IdeaToLink[]> {
  const searchParams = new URLSearchParams({ search, ideaId })

  const { data } = await httpClient.get<IdeasToLinkHttpResponse>(
    `/ideas/ideas/for-link?${searchParams.toString()}`,
  )

  const { ideas = [] } = data

  return ideas.map(({ id, sequence, title }) => ({
    value: id,
    label: title,
    sequence: `#${String(sequence).padStart(6, '0')}`,
  }))
}
